export default __webpack_public_path__ + "static/media/ezugi.f31987b9.svg";